import { __assign } from "tslib";
import { createLinesApi } from './lines';
import { createQueuesApi } from './queues';
import { createCallsApi } from './calls';
import { createIvrsApi } from './ivrs';
import { createCallCenterInsightsApi } from './insights';
export * from './insights';
export * from './queues';
export * from './calls';
export * from './ivrs';
export * from './lines';
export var buildStatsFilterFromDto = function (dto) {
    var filter = '';
    if (dto.queueId) {
        filter = "?queueId=".concat(dto.queueId);
    }
    else if (dto.locale) {
        filter = "?locale=".concat(dto.locale);
    }
    else if (dto.location) {
        filter = "?location=".concat(dto.location);
    }
    else if (dto.groupId) {
        filter = "?groupId=".concat(dto.groupId);
    }
    else if (dto.sortType) {
        filter = "?sortType=".concat(dto.sortType);
    }
    return filter;
};
export var createCallcenterApi = function (baseUrl, http) {
    var url = "".concat(baseUrl, "/callcenter");
    return {
        updateQueuesPriorities: function (dto) {
            return http.put("".concat(url, "/agents/").concat(dto.userId, "/queues/priorities"), dto);
        },
        getAgent: function (id) {
            return http.get("".concat(url, "/agents/").concat(id));
        },
        getDashboardStats: function (dto) {
            return http.post("".concat(url, "/stats"), dto);
        },
        getStats: function (dto) {
            var filter = buildStatsFilterFromDto(dto);
            return http.get("".concat(url, "/stats").concat(filter));
        },
        getQueuesStats: function (dto) {
            var filter = buildStatsFilterFromDto(__assign({}, dto));
            return http.get("".concat(url, "/stats/queues").concat(filter));
        },
        searchAgents: function (dto) {
            var temp = dto;
            if (dto.callCenterAgentSortType) { // TODO: remove this
                temp.sortType = dto.callCenterAgentSortType;
            }
            return http.post("".concat(url, "/agents/search"), temp);
        },
        addAgent: function (dto) {
            return http.post("".concat(baseUrl, "/agents/").concat(dto.id, "/callcenter"), {});
        },
        removeAgent: function (dto) {
            return http.delete("".concat(baseUrl, "/agents/").concat(dto.id, "/callcenter"));
        },
        getCurrentAgent: function () {
            return http.get("".concat(url, "/agents/me"));
        },
        setCallCenterActivity: function (dto) {
            return http.post("".concat(url, "/agents/activity"), dto);
        },
        setAgentsStatus: function (dto) {
            return http.post("".concat(url, "/agents/activity/admin"), dto);
        },
        syncAgent: function (userId) {
            return http.post("".concat(url, "/agents/sync"), { userId: userId });
        },
        startShift: function () { return http.post("".concat(url, "/agents/start-shift"), {}); },
        endShift: function () { return http.post("".concat(url, "/agents/end-shift"), {}); },
        calls: createCallsApi(url, http),
        getWorkerToken: function (ttlSeconds) {
            var query = ttlSeconds ? "?ttlSeconds=".concat(ttlSeconds) : '';
            return http.get("".concat(url, "/agents/worker-token").concat(query));
        },
        verifyCallCenter: function (dto) {
            return http.post("https://app.wixanswers.com/adminApi/cc-verification", dto);
        },
        enableAgentExtendedTimeout: function (dto) {
            return http.post("".concat(url, "/agents/").concat(dto.id, "/extendCallbackReservationTimeout/enable"), {});
        },
        disableAgentExtendedTimeout: function (dto) {
            return http.post("".concat(url, "/agents/").concat(dto.id, "/extendCallbackReservationTimeout/disable"), {});
        },
        updateAgentsQueueAssignments: function (dto) {
            return http.post("".concat(url, "/agents/queues"), dto);
        },
        queues: createQueuesApi(url, http),
        ivrs: createIvrsApi(url, http),
        lines: createLinesApi(url, http),
        insights: createCallCenterInsightsApi(baseUrl, http)
    };
};
//# sourceMappingURL=index.js.map